import React from 'react';
import { motion } from 'framer-motion';
export function SectionDivider() {
  return <div className="flex justify-center items-center py-16 opacity-60" aria-hidden="true" data-id="element-197">
      <motion.div initial={{
      width: 0
    }} whileInView={{
      width: '60px'
    }} viewport={{
      once: true
    }} transition={{
      duration: 1
    }} className="h-[1px] bg-gold/40" data-id="element-198" />
      <motion.span initial={{
      opacity: 0,
      scale: 0
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      delay: 0.3,
      duration: 0.5
    }} className="mx-4 text-gold text-xl font-serif" data-id="element-199">
        ✝
      </motion.span>
      <motion.div initial={{
      width: 0
    }} whileInView={{
      width: '60px'
    }} viewport={{
      once: true
    }} transition={{
      duration: 1
    }} className="h-[1px] bg-gold/40" data-id="element-200" />
    </div>;
}